import {Component, Input} from '@angular/core';
import {BaseResultComponent} from '../base-result/base-result.component';
import {DebtResult} from '../../../class/result/debt-result';
import {NbWindowService} from '@nebular/theme';

@Component({
  selector: 'app-debts-result',
  templateUrl: './debts-result.component.html',
  styleUrls: ['./debts-result.component.css']
})
export class DebtsResultComponent extends BaseResultComponent {

  @Input()
  debtResult: DebtResult;

  constructor(windowService: NbWindowService) {
    super(windowService);
  }

  get debts() {
    return this.debtResult.debts;
  }
  onResultImpl(): void {
  }

  ngOnInitImpl(): void {
  }
}
